import React, { Fragment, useEffect } from "react"
import { connect } from "react-redux"
import Footer from "./Footer"
import Nav from "./Nav"
import Container from "@mui/material/Container"
import { makeStyles } from "@mui/styles"
import ScrollToTop from "./ScrollToTop"
import { useSnackbar } from "notistack"
import { deleteErrorMessage } from "../actions"

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
  },
  container: {
    marginBottom: theme.spacing(10),
    backgroundImage: "url('../assets/parallax/parallax0@2x.png')"
  },
  childrenStyle: {
    minHeight: "65vh"
  }
}))

const Layout = (props) => {
  const { children, errorMessage, dispatch } = props
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()

  useEffect(() => {
    if (errorMessage) {
      enqueueSnackbar(errorMessage, { variant: "error"})
    }
    return () => dispatch(deleteErrorMessage())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage])

  return (
    <Fragment>
      <ScrollToTop />
      <div className={classes.root}>
        <Container maxWidth="lg" className={classes.container}>
          <Nav />
          <div className={classes.childrenStyle}>{children}</div>
        </Container>
        <Footer />
      </div>
    </Fragment>
  )
}


const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage
})

export default connect(mapStateToProps)(Layout)
